(function($) {

	$('.downloads__pagination-button').on('click', function(){
		$('.downloads__pagination-button--active').removeClass('downloads__pagination-button--active');
		$('.downloads__list--active').removeClass('downloads__list--active');

		$(this).addClass('downloads__pagination-button--active');
		var page = $(this).data('page');
		$('.downloads__list[data-page='+page+']').addClass('downloads__list--active')
		
	});


})( jQuery );